import { client } from "../../utils";
import Prismic from "prismic-javascript";

export const fetchTags = filters => dispatch => {
  client
    .query(Prismic.Predicates.at("document.type", "tags"), {
      orderings: "[my.tags.name]",
      ...filters
    })
    .then(res => {
      dispatch({
        type: "FETCH_TAGS",
        payload: res
      });
    });
};

export const fetchTagsNextPage = filters => dispatch => {
  client
    .query(Prismic.Predicates.at("document.type", "tags"), {
      orderings: "[my.tags.name]",
      ...filters
    })
    .then(res => {
      dispatch({
        type: "FETCH_TAGS_NEXT_PAGE",
        payload: res
      });
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/tagActions.js